<template>
    <div ref="refCompetencesContainer">
        <div class="title-row">
            <div class="title-label"
                v-for="(level, index) in levels"
                :key="level.key"
                :style="getLeftPosition(index)"
            >
                {{ level.name || 'Не известен' }}
            </div>
        </div>
        <div class="competences-content">
            <SoftCompetenceItem
                v-for="item in items"
                :key="item.id"
                :item="item"
                :levels="levels"
                :containerWidth="containerWidth"
            />
        </div>
    </div>
</template>

<script>
import SoftCompetenceItem from "./SoftCompetenceItem";
import { $helperGetLeftPosition } from "./helpers";

export default {
    name: "SoftCompetences",

    components: {
        SoftCompetenceItem,
    },

    props: {
        levels: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            containerWidth: 0,
        };
    },

    watch: {
        '$store.state.geometry.width'() {
            this.resizeHandler();
        },
    },

    mounted() {
        this.resizeHandler();
    },

    methods: {
        resizeHandler() {
            const container = this.$refs.refCompetencesContainer;
            this.containerWidth = container.offsetWidth;
        },

        getLeftPosition(index) {
            return $helperGetLeftPosition({
                index,
                length: this.levels.length - 1,
                containerWidth: this.containerWidth,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    &-row {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        height: 30px;
    }

    &-label {
        position: absolute;
        top: 0;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #98A0A9;
        transform: translate(-50%);
    }
}
.competences-content {

}
</style>